import { create } from "zustand";

export type AlertType = "success" | "info" | "warning" | "error";

export type SnackbarItem = {
  id: string;
  message: string;
  severity: AlertType;
};

type SnackbarStore = {
  snackbars: SnackbarItem[];
  addSnackbar: (item: Omit<SnackbarItem, "id">) => void;
  removeSnackbar: (id: string) => void;
};

export const snackbarStore = create<SnackbarStore>((set) => ({
  snackbars: [],
  addSnackbar: (item) => {
    const id = Date.now().toString();
    set((state) => ({
      snackbars: [...state.snackbars, { ...item, id }],
    }));

    setTimeout(() => {
      set((state) => ({
        snackbars: state.snackbars.filter((s) => s.id !== id),
      }));
    }, 3000);
  },
  removeSnackbar: (id) =>
    set((state) => ({
      snackbars: state.snackbars.filter((s) => s.id !== id),
    })),
}));
